import { Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import { LayoutComponent } from './features/public/layout/layout.component';
import { HomeComponent } from './features/public/home/home.component';

function matchEmptyUrl(segments: UrlSegment[]): UrlMatchResult | null {
    return segments.length === 0 ? { consumed: [] } : null;
}

export const routes: Routes = [
    { path: 'public', loadChildren: () => import('./features/public/public.routes').then(m => m.PUBLIC_ROUTES) },
    { path: 'private', loadChildren: () => import('./features/private/private.routes').then(m => m.PRIVATE_ROUTES) },

    // Minimal UX: show the public home page at '/' without changing the URL.
    {
        matcher: matchEmptyUrl,
        component: LayoutComponent,
        children: [
            { path: '', component: HomeComponent }
        ]
    },

    { path: '**', redirectTo: 'public/home' } // Redirect to home for any unknown routes
];
